
import { Route } from "react-router-dom";

export const renderRoutes = (routerConfig) =>
  (routerConfig || []).map(({ component: Component, children, ...routeProps }) =>
    <Route {...routeProps} render={(props) => <Component {...props} routes={children} />} key={routeProps.path} />
  )